/**
 * סטטוס נבחן (Member.occupation) — ולמי שבעמל הפרנסה / בעה"ב: לומד בחברותא או בשיעור, ועם מי.
 * Mirrors backend/src/utils/memberStudy.js.
 */
const SYSTEM_ID = String(process.env.REACT_APP_SYSTEM_ID || '').replace(/^["']|["']$/g, '').trim();
const IS_MISHTAMERET = SYSTEM_ID === 'waiting_client';

export const OCCUPATION_OPTIONS = IS_MISHTAMERET ? ['עמל הפרנסה', 'כולל', 'ישיבת היכל התורה'] : ['בעה"ב', 'אברך כולל'];
export const WORKING_OCCUPATIONS = ['עמל הפרנסה', 'בעה"ב'];
export const STUDY_FORMATS = ['חברותא', 'שיעור'];

export const isWorking = (occupation) => WORKING_OCCUPATIONS.includes(occupation || '');
/** "שם החברותא" / "שם המג"ש" — by the study format */
export const partnerLabel = (format) => (format === 'שיעור' ? 'שם המג"ש' : 'שם החברותא');
/** "חברותא: ישראל כהן" / "מג"ש: …" — '' when not relevant */
export function studyText(m) {
  if (!isWorking(m?.occupation) || !m?.studyFormat) return '';
  const who = m.studyFormat === 'שיעור' ? 'מג"ש' : 'חברותא';
  return m.studyPartner ? `${who}: ${m.studyPartner}` : m.studyFormat;
}
/** what is still missing for a working member: the format, or the name */
export function studyMissing(m) {
  if (!isWorking(m?.occupation)) return '';
  if (!m.studyFormat) return 'חסר: חברותא / שיעור';
  if (!m.studyPartner) return `חסר: ${partnerLabel(m.studyFormat)}`;
  return '';
}
